/* Artem Legrand: Judge.me — 1 review, +5 per click, then collapse. */
(function () {
  var STEP = 5;
  var INIT = 1;
  var shown = INIT;
  var total = 0;
  var busy = false;
  var mounted = false;

  function css() {
    return '.jdgm-review-widget .jdgm-review-list > .jm-review-item:nth-child(n+' +
      (shown + 1) +
      '){display:none!important}.jdgm-review-widget .jm-load-more-pagination{display:none!important}';
  }

  function setStyle() {
    var style = document.getElementById('al-jm-collapse');
    if (!style) {
      style = document.createElement('style');
      style.id = 'al-jm-collapse';
      document.head.appendChild(style);
    }
    style.textContent = css();
  }

  function pager() {
    return document.querySelector(
      '.jm-load-more-pagination button,.jm-load-more-pagination [role=button],.jm-load-more-pagination a'
    );
  }

  function loadUpTo(target, callback) {
    busy = true;
    var attempts = 0;
    var timer = setInterval(function () {
      var loaded = document.querySelectorAll('.jm-review-item').length;
      if (loaded >= target || loaded >= total) {
        clearInterval(timer);
        busy = false;
        if (callback) callback();
        return;
      }

      var nextPage = pager();
      if (nextPage) {
        nextPage.click();
        attempts = 0;
      } else {
        attempts += 1;
      }

      if (attempts >= 4) {
        clearInterval(timer);
        busy = false;
        if (callback) callback();
      }
    }, 300);
  }

  function label(button) {
    button.textContent = shown >= total ? 'Voir moins' : 'Afficher plus';
  }

  function init() {
    if (document.getElementById('al-jm-showall') || total <= 1) return;

    var list = document.querySelector('.jdgm-review-list');
    if (!list || !list.parentElement) return;

    shown = Math.min(INIT, total);
    setStyle();
    loadUpTo(shown);
    if (total <= INIT) return;

    var button = document.createElement('button');
    button.id = 'al-jm-showall';
    button.type = 'button';
    button.className = 'jm-button jm-button--primary';
    button.style.cssText = 'display:block;margin:12px auto 0';
    label(button);
    button.addEventListener('click', function () {
      if (busy) return;
      if (shown >= total) {
        shown = Math.min(INIT, total);
        setStyle();
        label(button);
        var widget = document.querySelector('.jdgm-review-widget');
        if (widget) widget.scrollIntoView({ block: 'center' });
        return;
      }

      var target = Math.min(shown + STEP, total);
      button.textContent = 'Chargement…';
      loadUpTo(target, function () {
        shown = target;
        setStyle();
        label(button);
      });
    });
    list.parentElement.appendChild(button);
  }

  function tryMount() {
    if (mounted) return true;
    try {
      if (window.jdgm && jdgm.data && jdgm.data.reviewWidget) {
        Object.keys(jdgm.data.reviewWidget).forEach(function (key) {
          var widget = jdgm.data.reviewWidget[key];
          if (widget && widget.pagination) widget.pagination.per_page = 1;
        });
      }

      var selector = document.querySelector('.jm-review-widget select,.jdgm-widget select');
      if (!selector || document.querySelectorAll('.jm-review-item').length < 1) return false;

      try {
        total = Object.values(jdgm.data.reviewWidget)[0].number_of_reviews;
      } catch (error) {
        total = document.querySelectorAll('.jm-review-item').length;
      }
      selector.dispatchEvent(new Event('change', { bubbles: true }));
      mounted = true;
      setTimeout(init, 700);
      return true;
    } catch (error) {
      return false;
    }
  }

  if (!tryMount()) {
    var observer = new MutationObserver(function () {
      if (tryMount()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }
})();
